var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 48,
    viewBox: "0 0 96 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 48,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1564 39V33.24H23.3964C24.4097 33.24 25.2231 32.9733 25.8364 32.44C26.4497 31.88 26.7564 31.12 26.7564 30.16C26.7564 29.52 26.6097 28.9733 26.3164 28.52C26.0497 28.04 25.6631 27.68 25.1564 27.44C24.6764 27.2 24.0897 27.08 23.3964 27.08H18.1564V21.56H23.0364C23.8897 21.56 24.5964 21.3467 25.1564 20.92C25.7164 20.4933 25.9964 19.8267 25.9964 18.92C25.9964 18.0133 25.7164 17.3467 25.1564 16.92C24.5964 16.4933 23.8897 16.28 23.0364 16.28H18.1564V10.52H25.2764C27.0097 10.52 28.5164 10.8533 29.7964 11.52C31.1031 12.16 32.1164 13.0533 32.8364 14.2C33.5564 15.32 33.9164 16.6133 33.9164 18.08C33.9164 20.1067 33.1964 21.76 31.7564 23.04C30.3164 24.32 28.2097 25.0533 25.4364 25.24L25.3564 22.48C28.3697 22.6667 30.6764 23.4933 32.2764 24.96C33.8764 26.4267 34.6764 28.3067 34.6764 30.6C34.6764 32.2533 34.2631 33.72 33.4364 35C32.6097 36.2533 31.4497 37.24 29.9564 37.96C28.4897 38.6533 26.7697 39 24.7964 39H18.1564ZM11.6764 39V10.52H19.5164V39H11.6764Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8684 39V32.2H71.5084C73.0018 32.2 74.2951 31.9333 75.3884 31.4C76.4818 30.84 77.3218 30 77.9084 28.88C78.4951 27.76 78.7884 26.3733 78.7884 24.72C78.7884 23.0667 78.4818 21.6933 77.8684 20.6C77.2818 19.5067 76.4418 18.6933 75.3484 18.16C74.2818 17.6 73.0018 17.32 71.5084 17.32H64.4684V10.52H71.5084C73.7484 10.52 75.8018 10.8533 77.6684 11.52C79.5618 12.1867 81.2018 13.1467 82.5884 14.4C83.9751 15.6533 85.0418 17.16 85.7884 18.92C86.5618 20.6533 86.9484 22.6 86.9484 24.76C86.9484 26.92 86.5618 28.88 85.7884 30.64C85.0418 32.3733 83.9751 33.8667 82.5884 35.12C81.2018 36.3733 79.5751 37.3333 77.7084 38C75.8418 38.6667 73.8018 39 71.5884 39H64.8684ZM59.5084 39V10.52H67.5084V39H59.5084Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 18L52.9952 21.75V29.25L46.5 33L40.0048 29.25V21.75L46.5 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a730f49e338c3c5e680143a243596061.svg";
export { ForwardRef as ReactComponent };